/**
 * 潜在客户列表 组件
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * 开放接口
 * handleFetch => fun(
 *     @页码，默认1;
 *    @flagUseLastSearch是否使用已用搜索条件,此配置不含前置条件不,默认false;
 *    @params 查询参数：选填，flagUseLastSearch为false可设置值，默认空;
 * )  => {}
 *
 * 必传参数
 * renderList           渲染列表
 *
 * 可选传参数：
 * searchFormOptions    搜索表格配置项，配置则显示搜索项
 * initFetch            进入是否查询 默认为true
 *
 * precondition     搜索前置条件
 * specialHandle    特别处理(查询前处理)
 *
 */
import React,{PureComponent,Fragment} from 'react';
import {Pagination, Spin,message,Tooltip,Space,Radio, Table,Button} from "antd";
import Lang from "@components/Lang/Lang";
import {isEmpty,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil,getWeek} from '@utils/utils';
import SearchForm from '@components/SearchForm/SearchForm';
import CustomerListService from "../CustomerList.action";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import UserScore from "../../components/UserScore";
import SeniorFilter from "./SeniorFilter"
import dayjs from 'dayjs';
import PropTypes from "prop-types";
import {lock} from "../../../../api/common/lock";
import CommonSelect from "@components//FormFormat/CommonSelect";
import FollowBtn from "@components/FollowUp/FollowBtn";
import UploadFile from '@/components/UploadFile/UploadFile';
import "./List.less";
const Locale = require("../../../../utils/locale").default;
const localeLang = Locale.current();
const RadioGroup = Radio.Group;

export default class List extends PureComponent{
    static propTypes = {
        searchFormOptions: PropTypes.array,
        initFetch: PropTypes.bool,
        precondition: PropTypes.object,
        flagShowSearchBtn: PropTypes.bool,
    }
    static defaultProps = {
        searchFormOptions: [],
        initFetch: true,
        paginationFlag: true,
        precondition:{},
        labelType:"1030",//	1010:新客标签 1020:成交客户标签
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list:[],
            pageSize:50,
            pageIndex: 1,
            total: 0,
            orderByType:"",//"10",//默认按注册时间,
            isKaBuyer:"-1",
            uploadSetting : {
                name: 'file',
                accept:'.xlsx, .xls',
                showUploadList: false,
                replace:true,
                multiple:false
            }
        }
    }
    /**
     * 搜索
     ***/
    getFormData(values={}) {
        const {searchFromDataSenior={}} = this.state;
        this.fetch(1,{...searchFromDataSenior,...values});
        this.setState({
            searchFromData:values
        })
    }
    /**
     * 高级搜索
     ***/
    setSeniorFormData(values={}) {
        this.setState({
            searchFromDataSenior:values
        })
    }
    /**
     * 重置
     **/
    searchReset(lastSearchCondition){
        this.fetch(1,lastSearchCondition);
    }
    changeKa(ka){
        this.loading(true);
        this.setState({
            isKaBuyer:ka,
        },()=>{
            this.fetch(1,this.state.lastSearchCondition);
        })
    }

    getOption(){
        const {allTabs=false,fxUserId,labelType} = this.props;
        // 目前不做权限  现在就是一个人在管理
        // let canOperation = row.canOperation;
        let canOperation = true;
        return {
            // cnTitle: '操作',
            // cnTitleId: 'CaoZuo',
            title: Lang({id: "CaoZuo", default: "操作"}),
            dataIndex: 'CaoZuo',
            width: 150,
            fixed:"right",
            render: (item = {}, row) => (
                <Space>
                    {/*完善资料 旧的跟进 | 分销商 账号不能 进入 */}
                    {isEmpty(fxUserId)&&<Fragment>
                        <FollowBtn row={row} labelType={labelType} buyerInternalId={row.buyerInternalId}
                                   refreshPage={()=>{
                                       this.fetch(1,this.state.lastSearchCondition);
                                       if(this.props.getStatistics){
                                           this.props.getStatistics();
                                       }
                                   }}
                                   disable={!canOperation} />
                        {/*<AuthBtn icon={"ri-verified-badge-line"} tips = {Lang(canOperation?{id:"WanShanZiLiao",default:"完善资料"}:{id:"ZanWuQuanXian",default:"暂无权限"})}
                                 className={canOperation?"blueIconTips":"btnDisabled"}
                                 onClick={canOperation?()=>this.lock(row.id, row.status === "out"?0:1):""} />*/}
                        <AuthBtn icon={"ri-verified-badge-line"} tips = {Lang(canOperation?{id:"WanShanZiLiao",default:"完善资料"}:{id:"ZanWuQuanXian",default:"暂无权限"})}
                                 className={canOperation?"blueIconTips":"btnDisabled"}
                                 onClick={()=>{
                                     window.open(`/customer/internalFollow?id=${row.buyerInternalId}&follow=${row.status === "out"?0:1}`,'about:blank')
                                 }} />
                    </Fragment>}
                </Space>
            )
        }
    }
    lock(id, type) {
        const data = {
            buyerId: id,
            expireTime: 3600,
        };
        lock(data)
            .then((response) => {
                if (response.data.success && response.data.valid) {
                    /*this.props.history.push(
                        `/customer/follow?id=${id}&follow=${type}`
                    );*/
                    window.open(`/customer/follow?id=${id}&follow=${type}`,'about:blank')

                } else {
                    message.info(
                        Lang({
                            id: "YouYeWuYuanZhengZaiGenJin",
                            default: "有业务员正在跟进，请勿重复操作",
                        })
                    );
                }
            })
            .catch((error) => {
                message.error(error.message);
            });
    }
    /**
     * 搜索
     * @param pageIndex 页码
     * @param fetchCondition 条件
     */
    fetch(pageIndex=1,fetchCondition={}){
        this.loading(true);
        const { precondition,labelType} = this.props;
        const { pageSize,orderByType,isKaBuyer} = this.state;
        // 处理 空值
        let newSearchMap = {...precondition,...fetchCondition};
        for(let key in newSearchMap){
            if(isEmpty(newSearchMap[key])) delete newSearchMap[key];
        }
        if(newSearchMap.followStatus=='-10'){
            delete newSearchMap.followStatus;
        }
        CustomerListService.fetch('/service/mg/follower/buyer-potential-list',pageSize, pageIndex,newSearchMap).then((resp)=>this.handleRes(resp.data,pageIndex,fetchCondition)).catch(err=>this.handleErr(err));
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    handleRes(res={},pageIndex=1,fetchCondition={}){
        this.loading(false);
        const {success,valid,models,paging={}} = res;
        if (success && valid) {
            if(this.props.fetchCallBack){
                this.props.fetchCallBack(res);
            }
            const resList = models || [];
            $(document).scrollTop(0);
            this.setState({
                list: resList,
                total: paging.total||0,
                pageIndex:pageIndex,
                lastSearchCondition:fetchCondition
            })
        }else {
            this.resetList();
            if(res.message)message.error(res.message);
        }
    }
    resetList(){
        this.setState({
            list: [],
            total: 0,
            pageIndex:1,
        })
    }
    handleErr(err){
        this.loading(false);
    }
    /**
     * 切换页码
     * **/
    onChangePage(page,currPageSize){
        const { pageSize } = this.state;
        if(currPageSize!=pageSize){
            this.setState({
                pageSize:currPageSize
            },()=>this.fetch(page,this.state.lastSearchCondition))
        }else this.fetch(page,this.state.lastSearchCondition);
    }
    onRefSearch = (ref) =>  this.onRefSearchChrld = ref;
    onChangeSort(item){
        this.setState({
            orderByType:item
        },()=>{
            this.fetch(1,this.state.lastSearchCondition);
        })
    }
    /**
     * 外部调用接口
     * @flag true 重置查询表单条件
     */
    reRefreshSearch(flag=true){
        if(flag){
            this.setState({
                loadingSearchFilterObj:true,
                orderByType:"",//"10",////默认按注册时间
            },()=>{
                this.setState({
                    loadingSearchFilterObj:false,
                })
                this.fetch(1)
            })
        }else{
            const { pageIndex=1, lastSearchCondition={}} = this.state;
            this.fetch(pageIndex,lastSearchCondition)
        }
    }
    /**
     * 上传文件后设置
     * **/
    handleUpload(file=[]){
        if(file.length>0){
            const fileId = file[0].fileId;
            this.onClickUpLoad(fileId)
        }
    }
    // 上传填充
    onClickUpLoad(fileId){
        this.loading(true)
        const sUrl = "/service/mg/follower/save-potential-buyer-import";
        CustomerListService.commonAction({
            fileId:fileId
        },sUrl).then(res => {
            this.loading(false);
            const data = res.data||{};
            const {success,valid,models={}} = data;
            if (success && valid) {
                if(models&&models.length){
                    message.info(Lang({id:"",default:models.join(",")}));
                }
                this.fetch(1,this.state.lastSearchCondition);
            } else if(data.message){
                if(models&&models.length>0){
                    message.info(<div style={{width:'400px',wordWrap: 'break-word',display: 'inline-block',
                        verticalAlign: 'top',textAlign:'left'}}>
                        {
                            models.map((item,index)=>{
                                return <div>{item}</div>
                            })
                        }
                        <div></div>
                    </div>);
                }else{
                    message.info(data.message);
                }
            }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
        })
    }
    componentWillMount() {
        const dList =__getDictList("is_ka_buyer")||[];
        let options= [
            { label:Lang({id:"QuanBu",default:"全部"}), value: '-1',  },
            // { label:Lang({id:"QuanBu",default:"KA客户"}), value: '1',  },
            // { label:Lang({id:"QuanBu",default:"非KA客户"}), value: '0',  },
        ]
        dList.forEach(item=>options.push({label:item.name,value:item.code+""}));
        this.setState({
            optionsKa: options
        })
    }
    componentDidMount() {
        if(this.props.onRef){
            this.props.onRef(this);
        }
        if(this.props.initFetch){
            this.fetch(1);
        }
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { searchFormOptions,flagShowSearchBtn,columns,precondition,allTabs=false, labelType=""} = this.props;
        const { list, loading,pageIndex,pageSize,total,orderByType,loadingSearchFilterObj=false,searchFromData={},optionsKa=[],isKaBuyer="",uploadSetting} = this.state;
        return ( <Spin spinning={loading}>
            <div className={'autoFetchList'}>
                {!loadingSearchFilterObj&&searchFormOptions.length>0&&<div className={'top-search'}>
                    <SearchForm
                        onRef={this.onRefSearch}
                        options = {searchFormOptions}
                        initialValues={precondition}
                        searchReset={(dat)=>this.searchReset(dat)}
                        flagShowReset={false}
                        flagShowSearchBtn={flagShowSearchBtn}
                        searchLeft={labelType=="1020"?<RadioGroup className={"mr_8"} options={optionsKa}
                                                                  onChange={(e)=>this.changeKa(e.target.value)} value={isKaBuyer} optionType="button" />:null}//1010:新客标签 1020:成交客户标签
                        setLeftBtnRight={<SeniorFilter search={(data=>{
                                                                    this.setSeniorFormData(data);
                                                                    this.fetch(1,{...searchFromData,...data})
                                                    })}
                                                    labelType={labelType}
                                                    isAllTab={allTabs}
                                                    searchReset={(dat)=>{
                                                        this.setSeniorFormData({});
                                                        this.searchReset(searchFromData)}
                                                    } />}
                        setRight={
                            <UploadFile {...uploadSetting}
                                        onChange={(fileList)=>{
                                            this.handleUpload(fileList);
                                        }}>
                                <Button className='btn-little-blue'>{Lang({id:"DaoRu",default:"导入"})}</Button>
                            </UploadFile>
                        }
                        getSearchValue={this.getFormData.bind(this)} />
                </div>}
                <Table columns={ [...columns, this.getOption()] }
                       pagination={false}
                       dataSource={list}  // 数据源
                       rowKey={record =>record.id}    // KEY
                       scroll={{ x: 1300 }}
                />
                    {list.length >0?<div className="margin-top-20 text-center"> {/*分页*/}
                    <Pagination total={total}
                        defaultPageSize={pageSize}
                        current={pageIndex}
                        showQuickJumper
                        onChange={this.onChangePage.bind(this)} />
                </div>:null}
            </div>
        </Spin> )
    }
}

